

function togolCartbuttondesiable(validInput = false) {

  const tableBody = document.getElementById("playerTableBody");

  const addToCartBtn = document.querySelector(
    'button.m-add-to-cart[type="submit"][name="add"]'
  );

  if (!addToCartBtn || !tableBody) return;

  const rows = tableBody.querySelectorAll("tr");

  /*
  |--------------------------------------------------------------------------
  | FORCE ENABLE (when Team_Order false)
  |--------------------------------------------------------------------------
  */
  if (validInput === true) {
    addToCartBtn.disabled = false;
    addToCartBtn.style.pointerEvents = "auto";
    addToCartBtn.style.opacity = "1";
    return;
  }

  /*
  |--------------------------------------------------------------------------
  | NO ROW = DISABLE
  |--------------------------------------------------------------------------
  */
  if (rows.length === 0) {
    addToCartBtn.disabled = true;
    addToCartBtn.style.pointerEvents = "none";
    addToCartBtn.style.opacity = "0.5";
    return;
  }

  let isValid = true;

  rows.forEach((row) => {

    const playerName = row.querySelector('[name="player_name[]"]')?.value.trim();
    const number     = row.querySelector('[name="number[]"]')?.value.trim();
    const genderFit  = row.querySelector('[name="gender_fit[]"]')?.value.trim();
    const size       = row.querySelector('[name="size[]"]')?.value.trim();
    const sleeve     = row.querySelector('[name="sleeve[]"]')?.value.trim();

    if (
      !playerName ||
      !number ||
      !genderFit ||
      !size ||
      !sleeve
    ) {
      isValid = false;
    }

  });

  if (isValid) {

    // ENABLE
    addToCartBtn.disabled = false;
    addToCartBtn.style.pointerEvents = "auto";
    addToCartBtn.style.opacity = "1";

  } else {

    // DISABLE
    addToCartBtn.disabled = true;
    addToCartBtn.style.pointerEvents = "none";
    addToCartBtn.style.opacity = "0.5";

  }
}



console.log("------------------------888888888888888888888888----------------------------------")
function buttonPaisi(productForm){

  /*
|--------------------------------------------------------------------------
| TOGGLE CART BUTTON ENABLE / DISABLE
|--------------------------------------------------------------------------
*/


  
  // const productForm = document.querySelector(
    //   "#product-form-template--26743047192872__main"
    // );
    
    /*
|--------------------------------------------------------------------------
| CREATE FULL UI USING JS
|--------------------------------------------------------------------------
*/

const wrapper = document.createElement("div");
wrapper.classList.add("custom-table")

wrapper.innerHTML = `
  <style>
  .player-table-wrapper {
    margin-top: 20px;
    overflow-x: auto;
    }

    #playerCsvFile {
  display: block;
  width: 100%;
  max-width: 280px;
  font-size: 13px;
  color: #6b7280;
  cursor: pointer;
  border: 1.5px dashed #d1d5db;
  border-radius: 8px;
      padding: 5px 7px;
  background: #ffffff;
  transition: border-color 0.2s, background 0.2s;
}

#playerCsvFile:hover {
  border-color: #9ca3af;
  background: #f9fafb;
}

#playerCsvFile:focus {
  outline: none;
  border-color: #6b7280;
}

#playerCsvFile::file-selector-button {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 5px 12px;
  margin-right: 10px;
  cursor: pointer;
  transition: background 0.15s;
}

#playerCsvFile::file-selector-button:hover {
  background: #e5e7eb;
}
    
    .player-top-actions {
      display: flex;
      gap: 12px;
      margin-bottom: 20px;
      align-items: center;
      flex-wrap: wrap;
      }
      
      .player-btn {
        background: #111827;
        color: #fff;
        border: none;
        padding: 10px 18px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
        }
        
        .player-delete-btn {
          background: transparent;
           border: none;
           color: #dc2626;

          }
          
          .player-table {
            width: 100%;
            border-collapse: collapse;
            
            }
            
            .player-table th,
            .player-table td {
              border: 1px solid #d1d5db;
              width: 15%;
              text-align: left;
              font-size: 14px;
              }
              
              .player-table th {
                background: #f3f4f6;
                }
                .player-table th {
                  padding: 6px 3px;
                }

              input[type="text"] {
                border: none!important;
                outline: none!important;
            }


                .player-table input,
                .player-table select,
                .player-table textarea {
                  width: 100%;
                  padding: 8px;
              
                  border-radius: 5px;
                  }
                  
                  .player-table textarea {
                    
                    resize: vertical;
                    }
                    #playerTableBody > tr > td:nth-child(6) > textarea{
                      border: none;
                      outline: none;
                    }
                      .warning-box{
                          margin-top: 20px;
    background-color: #f5f5f5;
    padding: 10px;
    border-radius: 6px;
    p {
    font-size: 14px;
            font-weight: 600;
}
            h3 {
    font-size: 16px;
    margin-bottom: 10px;
}
                      }
                    </style>

                    <div class="warning-box">
                    <h3>Team Roster</h3>
  <p class="hint">
    CSV Format: Name, Number, Size, Gender/Fit, Sleeve, Notes
  </p>

</div>
                    
                    <div class="player-table-wrapper">
                    
                    <div class="player-top-actions">

                    <button type="button" class="player-btn template-download" id="templateDownload">
                     ↓ Template
                    </button>

                    <button type="button" class="player-btn" id="addPlayerRow">
                    + Add Row
                    </button>
                    
                    
                    <input
                    type="file"
                    id="playerCsvFile"
                    accept=".csv"
                    />
                    </div>
                    
                    <table class="player-table">
                    <thead>
                    <tr>
                    <th>Player Name</th>
                    <th>Number</th>
                    <th>Gender/Fit</th>
                    <th>Size</th>
                    <th>Sleeve</th>
                    <th>Notes</th>
                    <th>Action</th>
                    </tr>
                    </thead>
                    
                    <tbody id="playerTableBody"></tbody>
                    </table>
                    
                    </div>
                    `;

                    productForm.appendChild(wrapper)
                    
                    
                    
                    
                    
                    // Add your custom logic here
                    
                    
                    
                    
                    /*
|--------------------------------------------------------------------------
| GET ELEMENTS AFTER APPEND
|--------------------------------------------------------------------------
*/

const tableBody = document.getElementById("playerTableBody");
const addRowBtn = document.getElementById("addPlayerRow");
const csvFile = document.getElementById("playerCsvFile");
const templateDownloadBtn = document.getElementById("templateDownload");

/*
|--------------------------------------------------------------------------
| UPDATE HIDDEN INPUTS
|--------------------------------------------------------------------------
*/

function updateHiddenFields() {
  // Step 1: form আলাদাভাবে নাও
  const productFormField = document.querySelector(
    "form#product-form-template--26743047192872__main[action='/cart/add']"
  );

  if (!productFormField) {
    console.warn("Product form পাওয়া যায়নি!");
    return;
  }

  // Step 2: আলাদাভাবে পুরনোগুলো remove করো
  productFormField
    .querySelectorAll(".dynamic-player-hidden")
    .forEach(el => {
      el.remove()

    });
  

  // Step 3: বাকি সব আগের মতোই
  const rows = tableBody.querySelectorAll("tr");

  rows.forEach((row, index) => {
    const playerName = row.querySelector('[name="player_name[]"]').value;
    const number     = row.querySelector('[name="number[]"]').value;
    const genderFit  = row.querySelector('[name="gender_fit[]"]').value;
    const size       = row.querySelector('[name="size[]"]').value;
    const sleeve     = row.querySelector('[name="sleeve[]"]').value;
    const notes      = row.querySelector('[name="notes[]"]').value;

    const hiddenInput = document.createElement("input");
    hiddenInput.type  = "hidden";
    hiddenInput.classList.add("dynamic-player-hidden");
    hiddenInput.name  = `properties[Player ${index + 1}]`;
    hiddenInput.value =
      `(Player Name: ${playerName}, ` +
      `Number: ${number}, ` +
      `Gender/Fit: ${genderFit}, ` +
      `Size: ${size}, ` +
      `Sleeve: ${sleeve}, ` +
      `Notes: ${notes})`;

    productFormField.appendChild(hiddenInput);
  });

  const headerInput = document.createElement("input");
  headerInput.type  = "hidden";
  headerInput.classList.add("dynamic-player-hidden");
  headerInput.name  = "properties[image table header]";
  headerInput.value = "Player Name, Number, Gender/Fit, Size, Sleeve, Notes";

  productFormField.appendChild(headerInput);
}



/*
|--------------------------------------------------------------------------
| CREATE ROW
|--------------------------------------------------------------------------
*/

const CONFIG = {
  Male:   { sizes: ["S","M","L","XL","2XL","3XL", "4XL", "5XL", "6XL", "7XL"], sleeves: ["Short","Long"] },
  Female: { sizes: ["S","M","L","XL","2XL","3XL", "4XL"],              sleeves: ["Short","Long"] },
  Kids:  { sizes: ["S","M","L","XL"],         sleeves: ["Short"] },
  Preschool: { sizes: ["S","M","L"],        sleeves: ["Short","Long"] }
};



templateDownloadBtn.addEventListener("click", () => {

  const fileUrl =
    "https://cdn.shopify.com/s/files/1/0960/1725/2648/files/team_roster_template.csv?v=1778666951";

  const link = document.createElement("a");

  link.href = fileUrl;
  link.download = "team_roster_template.csv";

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

});



function populateSelect(selectEl, options, selectedValue = "") {
  const currentVal = selectedValue || selectEl.value;
  selectEl.innerHTML = `<option value="">Select</option>`;
  options.forEach(opt => {
    const option = document.createElement("option");
    option.value = opt;
    option.textContent = opt;
    if (opt === currentVal) option.selected = true;
    selectEl.appendChild(option);
  });
}

function createRow(data = {}) {
  const tr = document.createElement("tr");

  tr.innerHTML = `
    <td><input type="text" name="player_name[]" value="${data.player_name || ""}" required/></td>
    <td><input type="text" name="number[]" value="${data.number || ""}"/></td>
    <td>
      <select name="gender_fit[]">
        <option value="">Select</option>
        <option value="Male"   ${data.gender_fit === "Male"   ? "selected" : ""}>Male</option>
        <option value="Female" ${data.gender_fit === "Female" ? "selected" : ""}>Female</option>
        <option value="Kids"  ${data.gender_fit === "Kids"  ? "selected" : ""}>Kids</option>
        <option value="Preschool" ${data.gender_fit === "Preschool" ? "selected" : ""}>Preschool</option>
      </select>
    </td>
    <td><select name="size[]"><option value="">Select</option></select></td>
    <td><select name="sleeve[]"><option value="">Select</option></select></td>
    <td><textarea name="notes[]" rows="1">${data.notes || ""}</textarea></td>
    <td><button type="button" class="player-btn player-delete-btn">Delete</button></td>
  `;

  const genderSelect = tr.querySelector('[name="gender_fit[]"]');
  const sizeSelect   = tr.querySelector('[name="size[]"]');
  const sleeveSelect = tr.querySelector('[name="sleeve[]"]');

  // Gender change হলে size ও sleeve update করার function
  function updateSizeAndSleeve(selectedGender, presetSize = "", presetSleeve = "") {
    if (CONFIG[selectedGender]) {
      populateSelect(sizeSelect,   CONFIG[selectedGender].sizes,   presetSize);
      populateSelect(sleeveSelect, CONFIG[selectedGender].sleeves, presetSleeve);
    } else {
      // Gender select না করলে empty রাখো
      sizeSelect.innerHTML   = `<option value="">Select</option>`;
      sleeveSelect.innerHTML = `<option value="">Select</option>`;
    }
  }

  // Row তৈরি হওয়ার সময় যদি data থেকে gender আসে (CSV import বা preset)
  if (data.gender_fit && CONFIG[data.gender_fit]) {
    updateSizeAndSleeve(data.gender_fit, data.size || "", data.sleeve || "");
  }

  // Gender change event
  genderSelect.addEventListener("change", () => {
    updateSizeAndSleeve(genderSelect.value);
    updateHiddenFields();
    togolCartbuttondesiable()
  });

  // Delete button
  tr.querySelector(".player-delete-btn").addEventListener("click", () => {
    tr.remove();
    removeTableWhenNoRow()
    updateHiddenFields();
    togolCartbuttondesiable()
  });

  // বাকি সব field change এ hidden update
  tr.querySelectorAll("input, select, textarea").forEach(field => {
    field.addEventListener("input",  ()=>{
      updateHiddenFields()
      togolCartbuttondesiable()
    });
    field.addEventListener("change", ()=>{
      updateHiddenFields()
      togolCartbuttondesiable()
    });
  });

  tableBody.appendChild(tr);
  updateHiddenFields();
  togolCartbuttondesiable()
}

function removeTableWhenNoRow (){
  const tableBody = document.querySelector("#playerTableBody");
  const playerTable = document.querySelector(".player-table")
  if(tableBody.innerHTML == ''){
    playerTable.style.display = "none"
  }else{
    playerTable.style.display = "block"
  }
}
removeTableWhenNoRow()



/*
|--------------------------------------------------------------------------
| ADD ROW BUTTON
|--------------------------------------------------------------------------
*/

addRowBtn.addEventListener("click", () => {
  createRow();
  removeTableWhenNoRow()
});

/*
|--------------------------------------------------------------------------
| CSV IMPORT
|--------------------------------------------------------------------------
*/



csvFile.addEventListener("change", (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();

  reader.onload = function(e) {
    const csv = e.target.result;

    // \r\n বা \n দুটোই handle করা
    const lines = csv.split(/\r?\n/).filter(line => line.trim() !== "");
    if (lines.length <= 1) {
      alert("No data found in CSV file");
      return;
    }

    const headers = lines[0].split(",").map(h => h.trim().toLowerCase().replace(/\s+/g, "_"));

    const errors = [];
    const validRows = [];

    for (let i = 1; i < lines.length; i++) {
      // comma-split কিন্তু quoted field handle করা
      const values = parseCSVLine(lines[i]);

      const rowData = {};
      headers.forEach((header, index) => {
        rowData[header] = values[index] ? values[index].trim() : "";
      });

      const rowErrors = validateRow(rowData, i);

      if (rowErrors.length > 0) {
        errors.push(`Row ${i}: ${rowErrors.join(", ")}`);
      } else {
        validRows.push(rowData);
      }
    }

    // Error থাকলে দেখাও কিন্তু valid row গুলো তবুও add করো
    if (errors.length > 0) {
      const proceed = confirm(
        `There are ${errors.length} issues in the following rows:\n\n${errors.join("\n")}\n\nDo you want to add the valid rows?`
      );
      if (!proceed) {
        csvFile.value = "";
        return;
      }
    }

    if (validRows.length === 0) {
      alert("No valid rows found");
      csvFile.value = "";
      return;
    }

    // Valid row গুলো table এ add করো
    validRows.forEach(rowData => {
      createRow({
        player_name: rowData.player_name || "",
        number:      rowData.number      || "",
        gender_fit:  rowData.gender_fit  || "",
        size:        rowData.size        || "",
        sleeve:      rowData.sleeve      || "",
        notes:       rowData.notes       || ""
      });
    });

    updateHiddenFields();
    togolCartbuttondesiable()
    removeTableWhenNoRow()
    csvFile.value = ""; // reset file input
  };

  reader.readAsText(file);
});

// csvFile.addEventListener("change", (event) => {

//   const file = event.target.files[0];

//   if (!file) return;

//   const reader = new FileReader();

//   reader.onload = function(e) {

//     const csv = e.target.result;

//     // handle windows/mac line break
//     const lines = csv
//       .split(/\r?\n/)
//       .filter(line => line.trim() !== "");

//     if (lines.length <= 1) {
//       alert("CSV তে কোনো data নেই।");
//       return;
//     }

//     // HEADER NORMALIZE
//     const headers = parseCSVLine(lines[0]).map(h =>
//       h
//         .replace(/^\uFEFF/, "")
//         .trim()
//         .toLowerCase()
//         .replace(/\s+/g, "_")
//     );

//     const errors = [];
//     const validRows = [];

//     for (let i = 1; i < lines.length; i++) {

//       const values = parseCSVLine(lines[i]);

//       const rowData = {};

//       headers.forEach((header, index) => {
//         rowData[header] = values[index]
//           ? values[index].trim()
//           : "";
//       });

//       const rowErrors = validateRow(rowData, i);

//       if (rowErrors.length > 0) {

//         errors.push(`Row ${i}: ${rowErrors.join(", ")}`);

//       } else {

//         validRows.push(rowData);

//       }

//     }

//     if (errors.length > 0) {

//       const proceed = confirm(
//         `নিচের ${errors.length}টি row-এ সমস্যা আছে:\n\n${errors.join("\n")}\n\nValid row গুলো add করবো?`
//       );

//       if (!proceed) {
//         csvFile.value = "";
//         return;
//       }

//     }

//     if (validRows.length === 0) {
//       alert("কোনো valid row পাওয়া যায়নি।");
//       csvFile.value = "";
//       return;
//     }

//     validRows.forEach(rowData => {

//       createRow({
//         player_name: rowData.player_name || "",
//         number:      rowData.number || "",
//         gender_fit:  rowData.gender_fit || "",
//         size:        rowData.size || "",
//         sleeve:      rowData.sleeve || "",
//         notes:       rowData.notes || ""
//       });

//     });

//     updateHiddenFields();
//     togolCartbuttondesiable();
//     removeTableWhenNoRow();

//     csvFile.value = "";

//   };

//   reader.readAsText(file);

// });

/*
|--------------------------------------------------------------------------
| CSV LINE PARSER — quoted field handle করে
|--------------------------------------------------------------------------
*/
function parseCSVLine(line) {
  const result = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];

    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === "," && !inQuotes) {
      result.push(current);
      current = "";
    } else {
      current += char;
    }
  }

  result.push(current);
  return result;
}

/*
|--------------------------------------------------------------------------
| VALIDATE ROW AGAINST CONFIG
|--------------------------------------------------------------------------
*/
function validateRow(rowData, rowIndex) {
  const errors = [];

  const gender = rowData.gender_fit ? rowData.gender_fit.trim() : "";
  const size   = rowData.size       ? rowData.size.trim()       : "";
  const sleeve = rowData.sleeve     ? rowData.sleeve.trim()     : "";

  // Gender check
  if (!gender) {
    errors.push("Gender/Fit is required");
  } else if (!CONFIG[gender]) {
    errors.push(`"${gender}" Invalid Gender/Fit selected. Please use Male, Female, Kids or Preschool.`);
  } else {
    // Gender valid — এখন size check
    if (!size) {
      errors.push("Size is required");
    } else if (!CONFIG[gender].sizes.includes(size)) {
      errors.push(`"${size}" is not a valid size for ${gender} (${CONFIG[gender].sizes.join("/")})`);
    }

    // Gender valid — এখন sleeve check
    if (!sleeve) {
      errors.push("Sleeve is required");
    } else if (!CONFIG[gender].sleeves.includes(sleeve)) {
      errors.push(`"${sleeve}" is not a valid sleeve for ${gender} (${CONFIG[gender].sleeves.join("/")})`);
    }
  }

  // Player name check
  if (!rowData.player_name || !rowData.player_name.trim()) {
    errors.push("Player Name is required");
  }

  return errors;
}

// csvFile.addEventListener("change", (event) => {
  
//   const file = event.target.files[0];
  
//   if (!file) return;
  
//   const reader = new FileReader();
  
//   reader.onload = function(e) {
    
//     const csv = e.target.result;
    
//     const lines = csv
//     .split("\n")
//     .filter(line => line.trim() !== "");
    
//     if (lines.length <= 1) return;
    
//     const headers = lines[0]
//     .split(",")
//     .map(h => h.trim().toLowerCase());
    
//     for (let i = 1; i < lines.length; i++) {
      
//       const values = lines[i].split(",");
      
//       const rowData = {};
      
//       headers.forEach((header, index) => {
        
//         rowData[header] = values[index]
//         ? values[index].trim()
//         : "";
//       });
      
//       createRow({
//         player_name: rowData.player_name || "",
//         number: rowData.number || "",
//         gender_fit: rowData.gender_fit || "",
//         size: rowData.size || "",
//         sleeve: rowData.sleeve || "",
//         notes: rowData.notes || ""
//       });
//     }

//     updateHiddenFields();
//   };
  
//   reader.readAsText(file);
// });



}

document.addEventListener("DOMContentLoaded", () => {
  const teamOrderInput = document.querySelector(
    "input.ymq-option-rc-input[value='Team_Order']"
  );

  console.clear();
  console.log("Team Order Input: ", teamOrderInput);

  let x = 1;

  const orderTypeSelectBox = document.querySelector(
    "div[ymq-option-label='Order Type']"
  );

  console.log("Order Type: ", orderTypeSelectBox);

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "ymq-option-checked"
      ) {
        const teamOrderInputData = teamOrderInput.getAttribute(
          "ymq-option-checked"
        );

        console.log("teamOrderInputData:", teamOrderInputData);

        // create only once
        if (teamOrderInputData === "true" && x === 1) {
          buttonPaisi(orderTypeSelectBox);
          x++;
        }

        const teamWraperTable =
          document.querySelector(".custom-table");

        if (teamWraperTable) {

          teamWraperTable.style.display =
            teamOrderInputData === "true"
              ? "block"
              : "none";

          // IMPORTANT
          setTimeout(() => {

            if (teamOrderInputData === "true") {

              togolCartbuttondesiable();

            } else {

              togolCartbuttondesiable(true);

            }

          }, 0);

}
      }
    });
  });

  observer.observe(teamOrderInput, {
    attributes: true,
    attributeFilter: ["ymq-option-checked"],
  });
});


// document.addEventListener("DOMContentLoaded", ()=> {
//   const teamOrderInput = document.querySelector("input.ymq-option-rc-input[value='Team_Order']");
//   console.clear();
//   console.log("Team Order Input: ", teamOrderInput);
//   let x = 1;
  
//   const orderTypeSelectBox = document.querySelector("div[ymq-option-label='Order Type']");
//   console.log("Order Type: ", orderTypeSelectBox);

//   teamOrderInput.addEventListener("change", () => {
//     const teamOrderInputData = teamOrderInput.getAttribute("ymq-option-checked")

//     console.log("teamOrderInputData:", typeof teamOrderInputData)
    
//     if(teamOrderInputData == "true" && x == 1) {
//       buttonPaisi(orderTypeSelectBox)
//       x++;

//     }
//     if(teamOrderInputData == "true") {
//       const teamWraperTable = document.querySelector(".custom-table");
//       teamWraperTable.style.display = "block";  // Changed == to =
//     } else {
//       const teamWraperTable = document.querySelector(".custom-table");
//       teamWraperTable.style.display = "none";   // Changed == to =
//     }
//   }, false)
// });



